import { CommonContexts } from '@epam/uui-core';

const svc: CommonContexts<any, any> = {} as any;

export default svc;
